import { Link } from "react-router-dom";
import { renderCustomColumnDefs } from "../../../../shared/Table/table.utils";
import { formatDate, renderAmount } from "../../../../utils";

/**
 * Gross for an invoice row. Uses the virtual total, then the stored calculated total.
 * @param {object} invoice
 * @returns {number}
 */
function invoiceGross(invoice) {
  if (!invoice) return 0;
  if (invoice.total != null && invoice.total !== 0) return invoice.total;
  return invoice.calculatedTotalCharges || invoice.total || 0;
}

// Config for Invoice report UI table
const tableConfig = [
  {
    id: "invoiceId",
    // Function header: string headers go through camelCaseToSpaces ("Invoice I D")
    header: () => "Invoice ID",
    minWidth: 120,
    cell: ({ getValue, row }) => {
      const value = getValue();
      const rowId = row.original._id;
      if (rowId) {
        return (
          <Link
            to={`/invoices/${rowId}`}
            className="text-primary-600 hover:underline cursor-pointer"
          >
            {value || rowId}
          </Link>
        );
      }
      return value || "-";
    },
  },
  {
    id: "dateCreated",
    header: "Date",
    minWidth: 120,
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return "-";
      return formatDate(value);
    },
  },
  {
    id: "client",
    header: "Client",
    minWidth: 150,
    cell: ({ getValue }) => {
      const client = getValue();
      if (!client) return "-";
      if (typeof client === "string") return client;
      return client?.name || client?.fullName || "-";
    },
  },
  {
    id: "status",
    header: "Status",
    minWidth: 100,
    cell: ({ getValue }) => getValue() || "-",
  },
  {
    id: "dueDate",
    header: "Due Date",
    minWidth: 120,
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return "-";
      return formatDate(value);
    },
  },
  {
    id: "totalBaseCharges",
    header: "Base",
    minWidth: 110,
    cell: ({ getValue }) => renderAmount(getValue() || 0),
  },
  {
    id: "totalDropCharges",
    header: "Drop",
    minWidth: 110,
    cell: ({ getValue }) => renderAmount(getValue() || 0),
  },
  {
    id: "totalFuelCharges",
    header: "Fuel",
    minWidth: 110,
    cell: ({ getValue }) => renderAmount(getValue() || 0),
  },
  {
    id: "totalOtherCharges",
    header: "Other",
    minWidth: 110,
    cell: ({ getValue }) => renderAmount(getValue() || 0),
  },
  {
    id: "total",
    header: "Gross",
    minWidth: 120,
    cell: ({ row }) => renderAmount(invoiceGross(row.original)),
  },
];

export const COLUMN_DEFINITIONS = renderCustomColumnDefs(tableConfig);
